import { c as _c } from "react/compiler-runtime";
import { SvgChevronright } from '@common/icon';
import { cn } from '@core/utils';
import { CustomLink } from '@/app/_components/CustomLink';
import { Image } from '@/components/client';
import { DONATION_ROUTES } from '@/constants';
import { BREAKPOINTS } from '@/constants/breakpoints';
import { DaysLeft } from './DaysLeft';
import { ProgressBar } from './ProgressBar';
interface ProjectCardProps {
  title: string;
  thumbnailUrl: string;
  businessId: number;
  slugId?: string;
  /** 남은 날자수 */
  daysLeft: number;
  donationAmount: number;
  achievementRate: number;
  institution?: {
    id: number | string;
    logoUrl: string;
    name: string;
  };
  isEnded?: boolean;
  onProjectLinkClick?: () => void;
}
export const ProjectCard = t0 => {
  const $ = _c(45);
  const {
    title,
    thumbnailUrl,
    businessId,
    slugId,
    daysLeft,
    donationAmount,
    achievementRate,
    institution,
    isEnded,
    onProjectLinkClick
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cn("relative overflow-hidden rounded-xlarge border border-Gray-300 transition-opacity duration-200 ease-out", "xl:hover:opacity-80", "active:opacity-80");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== businessId || $[2] !== slugId) {
    t2 = DONATION_ROUTES.HOMETOWN_BUSINESS_DETAIL.pathname({
      id: slugId ?? businessId
    });
    $[1] = businessId;
    $[2] = slugId;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = `${title} 지정기부사업 상세 페이지로 이동`;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = cn("absolute inset-0 z-10 rounded-xlarge", "focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-B-500");
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== onProjectLinkClick || $[6] !== t2 || $[7] !== t3) {
    t5 = <CustomLink href={t2} aria-label={t3} onClick={onProjectLinkClick} className={t4} />;
    $[5] = onProjectLinkClick;
    $[6] = t2;
    $[7] = t3;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== thumbnailUrl || $[10] !== title) {
    t6 = <div className="relative aspect-[335/180] w-full"><Image fill={true} sizes={`${BREAKPOINTS.MOBILE} 100vw, ${BREAKPOINTS.TABLET} 50vw, 314px`} src={thumbnailUrl} alt={title} className="object-cover" /></div>;
    $[9] = thumbnailUrl;
    $[10] = title;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const t7 = !institution;
  let t8;
  if ($[12] !== t7) {
    t8 = cn("mb-8 flex items-center justify-between", {
      "justify-end": t7
    });
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== institution) {
    t9 = institution ? <CustomLink href={DONATION_ROUTES.HOMETOWNS_DETAIL.withSearchParams({
      dynamicPath: {
        id: institution.id
      },
      searchParams: {
        tab: "projects"
      }
    })} aria-label={`${institution.name} 지자체 상세 페이지로 이동`} className={cn("group relative z-20 flex items-center gap-4 transition-opacity duration-200 ease-out", "xl:hover:opacity-80", "active:opacity-80", "focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-B-500")}><Image className="size-20 rounded-pill border border-Gray-300" src={institution.logoUrl} alt={institution.name} width={20} height={20} /><span className="mt-1 font-600 text-Gray-600 typo-caption1">{institution.name}</span><SvgChevronright className="size-12 text-Gray-600 transition-transform duration-200 ease-out group-focus-visible:translate-x-1 xl:group-hover:translate-x-1" /></CustomLink> : null;
    $[14] = institution;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== daysLeft || $[17] !== isEnded) {
    t10 = <DaysLeft value={daysLeft} isEnded={isEnded} />;
    $[16] = daysLeft;
    $[17] = isEnded;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== t8 || $[21] !== t9) {
    t11 = <div className={t8}>{t9}{t10}</div>;
    $[19] = t10;
    $[20] = t8;
    $[21] = t9;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== title) {
    t12 = <p className="mb-16 line-clamp-2 font-600 text-Gray-black typo-body3">{title}</p>;
    $[23] = title;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== achievementRate) {
    t13 = <ProgressBar progress={achievementRate} />;
    $[25] = achievementRate;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== achievementRate) {
    t14 = <span className="text-R-500">{achievementRate}%</span>;
    $[27] = achievementRate;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== donationAmount) {
    t15 = donationAmount.toLocaleString();
    $[29] = donationAmount;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== t15) {
    t16 = <span className="text-Gray-black">{t15}원</span>;
    $[31] = t15;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== t14 || $[34] !== t16) {
    t17 = <div className="mt-10 flex h-30 items-center justify-between gap-2 font-700 typo-body3">{t14}{t16}</div>;
    $[33] = t14;
    $[34] = t16;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== t11 || $[37] !== t12 || $[38] !== t13 || $[39] !== t17) {
    t18 = <div className="px-20 py-16">{t11}{t12}{t13}{t17}</div>;
    $[36] = t11;
    $[37] = t12;
    $[38] = t13;
    $[39] = t17;
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  let t19;
  if ($[41] !== t18 || $[42] !== t5 || $[43] !== t6) {
    t19 = <article className={t1}>{t5}{t6}{t18}</article>;
    $[41] = t18;
    $[42] = t5;
    $[43] = t6;
    $[44] = t19;
  } else {
    t19 = $[44];
  }
  return t19;
};